export type AsFirebasePayload<T> = {
  id: string;
  payload: T;
};

export type AsPayloadWithDraft<T> = {
  schemaVersion: number;
  revision: number;
  createdAt: string;
  updatedAt: string;
  publishedAt: string | null;
  latest: T | null; // latest will never be undefined
  draft: T | null; // draft will never be undefined
};

export type AsMapPayload<T> = {
  [key: string]: AsFirebasePayload<T>;
};

export type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends object ? RecursivePartial<T[P]> : T[P] | null | undefined;
};

export type FirebaseRequest<T> = {
  [P in keyof T]?: T[P] extends object ? RecursivePartial<T[P]> : T[P] | undefined;
};

export type Nullable<T> = T | null | undefined;

export function isDefined<T>(arg: T | null | undefined): arg is T {
  return arg !== null && arg !== undefined;
}
